import { jsxs as n, jsx as e } from "react/jsx-runtime";
import { SocialMedia as o } from "./SocialMedia.js";
import { TIPS as c, TIPS_LENGTH as r } from "../constants/tips.js";
const p = ({
  step: i,
  socialMediaLinks: t,
  sendEvent: a
}) => {
  const s = c[i - 1];
  return s ? /* @__PURE__ */ n("div", { className: "onboarding-content-container", children: [
    /* @__PURE__ */ e("div", { className: "svg-container", children: s.svg() }),
    s.isIllustration && /* @__PURE__ */ e("p", { className: "illustration-message", children: "Imagem Ilustrativa" }),
    /* @__PURE__ */ n("p", { className: "steps-count", children: [
      i,
      " de ",
      r
    ] }),
    /* @__PURE__ */ e("p", { className: "tip-message", children: s.tip }),
    i === r && /* @__PURE__ */ e(
      o,
      {
        socialMediaLinks: t,
        sendEvent: a
      }
    )
  ] }) : null;
};
export {
  p as Content
};
